<template>
  <div class="chat-window">
    <div class="chat-title">
      <p>上传记录</p>
      <!-- <p>21</p> -->
      <p>{{ total }}</p>
    </div>
    <div class="list-content">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column
          label="作品名称"
          align="center"
          width="250px"
          prop="name"
        >
          <template slot-scope="scope">{{ scope.row.name }}</template>
          <template slot-scope="scope">{{ scope.row.expressionName }}</template>
        </el-table-column>
        <el-table-column label="时间" align="center" prop="time">
          <template slot-scope="scope">{{ scope.row.time }}</template>
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>
        <el-table-column label="状态" width="120px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <span class="blueText"> / </span>
            <el-popconfirm title="您确定要删除这个表情吗？" @confirm="handleDel(scope.row)">
              <el-button 
                 slot="reference"
                 type="text"
                 class="redText"
                 >删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total,prev, pager, next"
        :page-size="listQuery.pageSize"
        :current-page.sync="listQuery.pageNo"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import upload from "@/api/apiModel/upload";
import api from "@/api/api";
export default {
  // 上传的表情记录
  name: "uploadRecord",
  data() {
    return {
      tableData: [],
      total: null,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 编辑 表情
    handleEdit(row) {
      upload.getExpressionDetail(row.id).then((res) => {
        let data = res.result;
        this.$emit("expressionDetail", data);
      });
    },
    //删除表情
    handleDel(row) {
      console.log(row)
      api.other.deleteExpression(row.id).then(res=>{
         if(res.code!=200){
           this.$message.error(res.message);
         }else{
           this.getList()
           this.$emit("delSuccess")
           this.$message({
           message: '删除成功',
          type: 'success'
        });
         }
      }).catch(err=>{
        this.$message.error(err.message);
      })
    },
    // 获取上传表情记录列表
    getList() {
      upload.getUploadExpression(this.listQuery).then((res) => {
        this.tableData = res.result.records;
        this.total = res.result.total;
      });
    },
    // 分页处理
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNo = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
.chat-window {
  min-width: 506px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid #dcdfe6;
}
.chat-window .chat-title {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 18px;
  color: #313233;
  letter-spacing: 2px;
  padding: 0 20px;
  background: #ffffff;
  box-sizing: border-box;
  border-bottom: 1px solid #dcdfe6;
}
.chat-window .chat-title p:nth-child(2) {
  font-size: 18px;
  color: #7b7d80;
  margin-left: 8px;
}
.list-content {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.pagination-container {
  padding: 15px 20px;
  border-top: 1px solid #dcdfe6;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.blueText {
  color: #409eff;
}
.redText {
  color: #f56c6c;
}
</style>